import { X, Plus } from "lucide-react";
import { useState } from "react";

export const PREDEFINED_TAGS = [
  { label: "Hot Lead", className: "bg-red-100 text-red-700 border-red-200" },
  { label: "Warm", className: "bg-amber-100 text-amber-800 border-amber-200" },
  { label: "Cold", className: "bg-zinc-100 text-zinc-700 border-zinc-200" },
  { label: "Follow-up", className: "bg-violet-100 text-violet-800 border-violet-200" },
  { label: "Decision Maker", className: "bg-blue-100 text-blue-700 border-blue-200" },
];

export function tagClass(label) {
  const t = PREDEFINED_TAGS.find((x) => x.label.toLowerCase() === (label || "").toLowerCase());
  return t ? t.className : "bg-zinc-900 text-white border-zinc-900";
}

export default function TagPicker({ value = [], onChange }) {
  const [custom, setCustom] = useState("");
  const safeList = Array.isArray(value) ? value.filter((v) => typeof v === "string" && v.trim()) : [];
  const has = (t) => safeList.map((v) => v.toLowerCase()).includes((t || "").toLowerCase());

  const toggle = (t) => {
    if (has(t)) onChange(safeList.filter((v) => v.toLowerCase() !== (t || "").toLowerCase()));
    else onChange([...safeList, t]);
  };

  const addCustom = () => {
    const v = custom.trim();
    if (!v || has(v)) return;
    onChange([...safeList, v]);
    setCustom("");
  };

  return (
    <div className="flex flex-col gap-3" data-testid="tag-picker">
      <div className="flex flex-wrap gap-2">
        {PREDEFINED_TAGS.map((t) => {
          const active = has(t.label);
          return (
            <button
              type="button"
              key={t.label}
              data-testid={`tag-toggle-${t.label.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => toggle(t.label)}
              className={`px-3 py-1.5 rounded-full text-sm font-bold border transition-all active:scale-95 ${
                active ? t.className : "bg-white text-zinc-500 border-zinc-200 hover:border-zinc-400"
              }`}
            >
              {t.label}
            </button>
          );
        })}
      </div>

      {safeList.filter((v) => !PREDEFINED_TAGS.some((p) => p.label.toLowerCase() === v.toLowerCase())).length > 0 && (
        <div className="flex flex-wrap gap-2">
          {safeList
            .filter((v) => !PREDEFINED_TAGS.some((p) => p.label.toLowerCase() === v.toLowerCase()))
            .map((v) => (
              <span
                key={v}
                className="inline-flex items-center gap-1 px-3 py-1.5 rounded-full text-sm font-bold bg-zinc-900 text-white"
                data-testid={`tag-custom-${v}`}
              >
                {v}
                <button
                  type="button"
                  onClick={() => onChange(value.filter((x) => x !== v))}
                  className="hover:opacity-70"
                  aria-label="remove tag"
                >
                  <X className="h-3.5 w-3.5" />
                </button>
              </span>
            ))}
        </div>
      )}

      <div className="flex gap-2">
        <input
          className="ls-input flex-1"
          placeholder="Add custom tag"
          value={custom}
          onChange={(e) => setCustom(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              e.preventDefault();
              addCustom();
            }
          }}
          data-testid="tag-custom-input"
        />
        <button
          type="button"
          onClick={addCustom}
          className="h-12 px-4 rounded-lg bg-zinc-100 text-zinc-900 font-bold flex items-center gap-1 hover:bg-zinc-200 active:scale-95 transition"
          data-testid="tag-custom-add"
        >
          <Plus className="h-4 w-4" /> Add
        </button>
      </div>
    </div>
  );
}
